import List from 'list.js';

const MOBILE_DISPLAY_AMOUNT = 12;
const DESKTOP_DISPLAY_AMOUNT = 12;

const initProjectListings = () => {
    const projectListings =
        document.querySelectorAll<HTMLElement>('.project-listing');
    const mql = window.matchMedia('(min-width: 768px)');

    projectListings.forEach(projectListing => {
        const projectListingItems =
            projectListing.querySelectorAll<HTMLLIElement>(
                'ul.project-listing-list > li'
            );

        const projectListingShowMore =
            projectListing.querySelector<HTMLButtonElement>(
                '.project-listing-show-more'
            );

        const initialDisplayAmount = mql.matches
            ? DESKTOP_DISPLAY_AMOUNT
            : MOBILE_DISPLAY_AMOUNT;

        showDisplayableItems(projectListingItems, initialDisplayAmount);
        showLoadMoreButton(
            projectListingItems,
            projectListingShowMore,
            initialDisplayAmount
        );

        projectListingShowMore?.addEventListener('click', () => {
            const newDisplayNumber = Math.min(
                getDisplayNumber(projectListing) +
                    (mql.matches
                        ? DESKTOP_DISPLAY_AMOUNT
                        : MOBILE_DISPLAY_AMOUNT),
                projectListingItems.length
            );
            showDisplayableItems(projectListingItems, newDisplayNumber);
            showLoadMoreButton(
                projectListingItems,
                projectListingShowMore,
                newDisplayNumber
            );
        });

        mql.addEventListener('change', () => {
            const displayNumber = getDisplayNumber(projectListing);
            const adjustedDisplayNumber = mql.matches
                ? Math.max(displayNumber, DESKTOP_DISPLAY_AMOUNT)
                : displayNumber;
            const currentProjectListingItems =
                projectListing.querySelectorAll<HTMLLIElement>(
                    'ul.project-listing-list li'
                );
            showDisplayableItems(currentProjectListingItems, adjustedDisplayNumber);
            showLoadMoreButton(
                currentProjectListingItems,
                projectListingShowMore,
                adjustedDisplayNumber
            );
        });

        const projectListingList = new List(
            projectListing,
            {
                listClass: 'project-listing-list',
                valueNames: [
                    { data: ['status'] }
                ]
            }
        );

        const projectListingSelect = projectListing.querySelector<HTMLSelectElement>('.project-listing-status-select select');
        projectListingSelect?.addEventListener('change', e => {
            projectListingList.search((e.target as HTMLSelectElement).value);
            const filteredProjectListingItems =
                projectListing.querySelectorAll<HTMLLIElement>(
                    'ul.project-listing-list li'
                );
            showDisplayableItems(filteredProjectListingItems, initialDisplayAmount);
            showLoadMoreButton(
                filteredProjectListingItems,
                projectListingShowMore,
                initialDisplayAmount
            );
        });
    });
};

const getDisplayNumber = (projectListing: HTMLElement): number => {
    const displayedItems = projectListing.querySelectorAll(
        'ul.project-listing-list li:not(.hide)'
    );

    return displayedItems.length;
};

const showDisplayableItems = (
    listItems: NodeListOf<HTMLLIElement>,
    displayNumber: number
) => {
    listItems.forEach((listItem, index) => {
        if (index >= displayNumber) {
            listItem.classList.add('hide');
        } else {
            listItem.classList.remove('hide');
        }
    });
};

const showLoadMoreButton = (
    listItems: NodeListOf<HTMLLIElement>,
    showMore: HTMLButtonElement | null,
    displayNumber: number
) => {
    if (displayNumber < listItems.length) {
        showMore?.classList.add('show');
    } else {
        showMore?.classList.remove('show');
    }
};

document.addEventListener('DOMContentLoaded', initProjectListings);
